/* ═══════════════════════════════════════════════════════════════
   MEW theme JS. Adapted from the approved v17 prototype.
   Every behaviour is guarded by element presence, so this one file
   is safe to load on every template (home / product / story / cart).
   Cart, currency and translation are handled by Shopify itself.
   ═══════════════════════════════════════════════════════════════ */
(function(){
'use strict';
const $=s=>document.querySelector(s);
const $$=s=>Array.from(document.querySelectorAll(s));
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const lerp=(a,b,t)=>a+(b-a)*t;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const hexSoft=(hex,a)=>{try{const n=parseInt(hex.replace('#',''),16);return `rgba(${n>>16&255},${n>>8&255},${n&255},${a})`;}catch(e){return `rgba(122,34,48,${a})`;}};

/* ── tiny tween ── */
function tween(dur,ease,onU,onC){const t0=performance.now();(function f(now){const p=clamp((now-t0)/dur,0,1);onU(ease(p));p<1?requestAnimationFrame(f):onC&&onC();})(t0);}
const powIn=t=>t*t*t, backOut=t=>{const c=1.2;return 1+(c+1)*Math.pow(t-1,3)+c*Math.pow(t-1,2);};

/* ── loader ── */
(function(){
  const loader=$('#loader');if(!loader){return;}
  const fill=$('#ldFill'),num=$('#ldNum'),hdr=$('#hdr'),h1=$('#heroH1');
  const T=1400,t0=performance.now(),ez=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
  function tick(now){const p=Math.min(1,(now-t0)/T),v=Math.round(ez(p)*100);
    if(fill)fill.style.width=v+'%';if(num)num.textContent=String(v).padStart(3,'0');
    p<1?requestAnimationFrame(tick):finish();}
  function finish(){setTimeout(()=>{
    loader.classList.add('done');
    if(hdr)hdr.classList.remove('hide');
    if(h1)h1.classList.add('play');
    const he=$('#heroEyebrow');if(he)he.style.opacity=1;
    setTimeout(()=>$$('#hero .rv, #heroSub, #heroCta, .story-hero .rv').forEach((el,i)=>setTimeout(()=>el.classList.add('in'),i*90)),500);
    setTimeout(()=>loader.remove(),1200);
  },220);}
  reduced?finish():requestAnimationFrame(tick);
})();

/* ── header solid ── */
(function(){const h=$('#hdr');if(h)h.classList.add('solid');})();

/* ── cursor + magnetic ── */
(function(){
  const dot=$('.cur-dot'),ring=$('.cur-ring');if(!dot||!ring){return;}
  let tx=innerWidth/2,ty=innerHeight/2,rx=tx,ry=ty;
  addEventListener('pointermove',e=>{tx=e.clientX;ty=e.clientY;dot.style.left=tx+'px';dot.style.top=ty+'px';},{passive:true});
  document.addEventListener('pointerover',e=>{
    document.body.classList.toggle('hov',!!e.target.closest('a,button,summary,select'));
    document.body.classList.toggle('hov-shade',!!e.target.closest('.swatch'));
  });
  (function loop(){rx=lerp(rx,tx,.16);ry=lerp(ry,ty,.16);ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(loop);})();
  $$('.mag').forEach(el=>{
    el.addEventListener('pointermove',e=>{const r=el.getBoundingClientRect();
      el.style.transform=`translate(${(e.clientX-(r.left+r.width/2))/r.width*10}px,${(e.clientY-(r.top+r.height/2))/r.height*8}px)`;});
    el.addEventListener('pointerleave',()=>{el.style.transition='transform .5s cubic-bezier(.22,1,.36,1)';el.style.transform='';setTimeout(()=>el.style.transition='',500);});
  });
})();

/* ── reveals (shared) ── */
(function(){
  const els=$$('.rv');if(!els.length&&!$('#anat')){return;}
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.16});
  els.forEach(el=>io.observe(el));
  const anat=$('#anat');if(anat)io.observe(anat);
})();

/* ── HERO: floating petals + 3D wordmark ── */
const PET=[];
(function(){
  const hero=$('#hero'),bg=$('#floatBg'),fg=$('#floatFg');if(!hero||!bg||!fg){return;}
  const petal=c=>`<svg viewBox="0 0 40 40"><path class="fill" fill="${c}" d="M20 2 C30 10 34 22 20 38 C6 22 10 10 20 2 Z" opacity=".9"/></svg>`;
  const spots=[[fg,96,'18%','20%',1],[fg,72,'30%','74%',1],[fg,84,'12%','55%',1],[bg,54,'40%','12%',.55],[bg,48,'22%','86%',.5]];
  const pal=['#A64B58','#F78698','#C28579','#5C0F19','#B08570'];
  spots.forEach(([c,sz,top,left,op],i)=>{
    const d=document.createElement('div');d.className='fl';
    d.style.cssText=`width:${sz}px;height:${sz}px;top:${top};left:${left};opacity:${op}`;
    d.innerHTML=petal(pal[i%5]);c.appendChild(d);
    PET.push({el:d,rx:0,ry:0,bx:0,by:0,ang:Math.random()*360,i});
  });
  let mouse={x:0,y:0,px:innerWidth/2,py:innerHeight/2},cm={x:0,y:0};
  addEventListener('mousemove',e=>{mouse.x=e.clientX/innerWidth-.5;mouse.y=e.clientY/innerHeight-.5;mouse.px=e.clientX;mouse.py=e.clientY;},{passive:true});
  (function heroLoop(){
    requestAnimationFrame(heroLoop);
    if(hero.getBoundingClientRect().bottom<=0){return;}
    const time=Date.now()*.001;
    cm.x=lerp(cm.x,mouse.x,.05);cm.y=lerp(cm.y,mouse.y,.05);
    const hh=$('#heroH1');
    if(hh){
      const yaw=Math.sin(time*0.34)*13+cm.x*10, pitch=Math.sin(time*0.24+0.7)*3.2-cm.y*7;
      hh.style.transform=`rotateX(${pitch}deg) rotateY(${yaw}deg)`;
      hh.querySelectorAll('b').forEach((w,wi)=>{
        const depth=26+Math.sin(time*0.5+wi*0.9)*16, face=Math.cos(yaw*Math.PI/180);
        w.style.transform=`translateZ(${depth}px)`;w.style.filter=`brightness(${(0.92+face*0.1).toFixed(3)})`;
      });
    }
    fg.style.transform=`translate(${cm.x*60}px,${cm.y*60}px)`;
    bg.style.transform=`translate(${cm.x*-30}px,${cm.y*-30}px)`;
    PET.forEach((p,i)=>{
      const r=p.el.getBoundingClientRect();
      const dx=mouse.px-(r.left+r.width/2),dy=mouse.py-(r.top+r.height/2),dist=Math.hypot(dx,dy)||1;
      let trx=0,tryy=0,sp=1;
      if(dist<380){const f=(380-dist)/380;trx=dx/dist*f*-80;tryy=dy/dist*f*-80;sp=1+f*5;}
      p.rx=lerp(p.rx,trx,.1);p.ry=lerp(p.ry,tryy,.1);p.ang+=.18*sp;
      const dur=[5,7,6,8,5.5,6.5,9,11,10,7.5,8.5,6.2][i%12];
      const ph=(time+i*.7)*(Math.PI*2/dur);
      p.el.style.transform=`translate(${p.rx+p.bx}px,${p.ry+p.by+Math.sin(ph)*14}px) rotate(${p.ang*.15+Math.cos(ph)*8}deg)`;
    });
  })();
})();

/* ── UNBOX scroll scene ── */
(function(){
  const unbox=$('#unbox'),rig=$('#rig'),box=$('#box'),lid=$('#lid'),
        boxTube=$('#boxTube'),boxGlow=$('#boxGlow'),boxTitle=$('#boxTitle'),
        boxFinal=$('#boxFinal'),stage=$('#stage');
  if(!unbox||!rig||!stage){return;}
  let sy=0;addEventListener('scroll',()=>sy=scrollY,{passive:true});
  (function loop(){
    requestAnimationFrame(loop);
    const r=unbox.getBoundingClientRect();
    const total=unbox.offsetHeight-innerHeight;
    const p=clamp(-r.top/total,0,1);
    if(r.bottom>0&&r.top<innerHeight){
      stage.classList.toggle('lit',p>.15&&p<.95);
      const a=clamp(p/.18,0,1),b=clamp((p-.18)/.24,0,1),c=clamp((p-.34)/.40,0,1),d=clamp((p-.74)/.26,0,1);
      const ez=x=>1-Math.pow(1-x,3),eA=ez(a),eB=ez(b),eC=ez(c),eD=ez(d);
      rig.style.transform=`translateY(${(1-eA)*90}px) rotateX(${-8+eA*4}deg) rotateY(${-26+eA*14+eD*6}deg) scale(${.86+eA*.14})`;
      rig.style.opacity=Math.min(1,a*2);
      if(lid)lid.style.transform=`rotateX(${90+eB*118}deg)`;
      if(boxTube){boxTube.style.transform=`translateY(${34-eC*66}%) scale(${.82+eC*.26+eD*.1}) rotateY(${eD*-6}deg)`;boxTube.style.opacity=Math.min(1,b*1.4);}
      if(box){box.style.opacity=1-eD;box.style.transform=`translateY(${eD*130}px) scale(${1-eD*.12})`;}
      if(boxGlow)boxGlow.style.opacity=eC*.9;
      if(boxTitle){boxTitle.style.opacity=1-clamp(p/.14,0,1);boxTitle.style.transform=`translateY(${-clamp(p/.14,0,1)*20}px)`;}
      if(boxFinal){boxFinal.style.opacity=eD;boxFinal.style.transform=`translateY(${(1-eD)*24}px)`;}
    }
  })();
})();

/* ── FORMULA veins (self-healing connectors) ── */
(function(){
  const anat=$('#anat'),svg=$('#veins'),img=$('#anatImg');if(!anat||!svg){return;}
  function draw(){
    if(!img)return;
    if(innerWidth<980){svg.innerHTML='';return;}
    const ar=anat.getBoundingClientRect(),ir=img.getBoundingClientRect();
    svg.setAttribute('viewBox',`0 0 ${ar.width} ${ar.height}`);svg.setAttribute('width',ar.width);svg.setAttribute('height',ar.height);
    let h='';
    anat.querySelectorAll('.col .ing').forEach(ing=>{
      const r=ing.getBoundingClientRect(),fromRight=!!ing.closest('.colR');
      const sx=fromRight? r.left-ar.left-12 : r.right-ar.left+12, syy=r.top-ar.top+13;
      const ex=fromRight? ir.right-ar.left+4 : ir.left-ar.left-4;
      const ey=Math.min(Math.max(syy, ir.top-ar.top+ir.height*.12), ir.top-ar.top+ir.height*.88), mx=(sx+ex)/2;
      h+=`<path d="M ${sx} ${syy} C ${mx} ${syy}, ${mx} ${ey}, ${ex} ${ey}"/><circle cx="${sx}" cy="${syy}" r="3"/><circle cx="${ex}" cy="${ey}" r="3"/>`;
    });
    svg.innerHTML=h;
  }
  addEventListener('resize',draw);addEventListener('load',()=>{draw();setTimeout(draw,600);});
  if(img)img.addEventListener('load',draw);setTimeout(draw,1200);
})();

/* ── shade panel tilt ── */
(function(){
  const st=$('#shadeStage'),tl=$('#shadeTilt');if(!st||!tl){return;}
  let a=0,b=0,ca=0,cb=0;
  st.addEventListener('pointermove',e=>{const r=st.getBoundingClientRect();a=((e.clientX-r.left)/r.width-.5)*18;b=-((e.clientY-r.top)/r.height-.5)*14;});
  st.addEventListener('pointerleave',()=>{a=0;b=0;});
  (function l(){ca=lerp(ca,a,.08);cb=lerp(cb,b,.08);tl.style.transform=`rotateY(${ca}deg) rotateX(${cb}deg)`;requestAnimationFrame(l);})();
})();

/* ── GLOSS: variant shades (data-driven from Shopify variants/metafields) ── */
(function(){
  const list=$('#shadeList');if(!list){return;}
  const swatches=$$('.swatch');
  const nameEls=$$('#shadeName b');
  const desc=$('#shadeDesc'),fin=$('#shadeFin'),variantInput=$('#variantId'),pourLayer=$('#pour'),addBtn=$('#addBtn');
  function apply(i,origin){
    const sw=swatches[i];if(!sw)return;
    const hex=sw.dataset.hex||'#7a2230';
    document.documentElement.style.setProperty('--accent',hex);
    document.documentElement.style.setProperty('--accent-soft',hexSoft(hex,.35));
    swatches.forEach((s,si)=>{s.setAttribute('aria-pressed',String(si===i));s.classList.toggle('unavailable',s.dataset.available==='false');});
    nameEls.forEach((b,bi)=>b.classList.toggle('on',bi===i));
    $$('.pd-img').forEach((m,mi)=>m.classList.toggle('on',mi===i));
    if(desc&&sw.dataset.desc)desc.textContent=sw.dataset.desc;
    if(fin)fin.textContent=sw.dataset.finish||'';
    const price=document.getElementById('pdPrice');if(price&&sw.dataset.price)price.innerHTML=sw.dataset.price;
    // availability: prevent adding a sold-out shade (avoids Shopify 422)
    if(addBtn){const avail=sw.dataset.available!=='false';addBtn.disabled=!avail;
      addBtn.innerHTML=avail?((addBtn.dataset.add||'add to bag')+' <span class="arr">→</span>'):(addBtn.dataset.sold||'sold out');}
    if(variantInput&&sw.dataset.variant){variantInput.value=sw.dataset.variant;
      try{const u=new URL(location.href);u.searchParams.set('variant',sw.dataset.variant);history.replaceState({},'',u);}catch(e){}}
    // pour ripple
    if(!reduced&&origin&&pourLayer){
      const sp=document.createElement('span');
      const dm=Math.hypot(Math.max(origin.x,innerWidth-origin.x),Math.max(origin.y,innerHeight-origin.y))*2.2;
      sp.style.cssText=`left:${origin.x}px;top:${origin.y}px;width:${dm}px;height:${dm}px;background:${hex}`;
      pourLayer.appendChild(sp);sp.classList.add('go');sp.addEventListener('animationend',()=>sp.remove());
    }
  }
  swatches.forEach((sw,i)=>sw.addEventListener('click',e=>apply(i,{x:e.clientX,y:e.clientY})));
  // init to selected/first
  let start=swatches.findIndex(s=>s.getAttribute('aria-pressed')==='true');
  apply(start<0?0:start);
})();

/* ── qty stepper (updates hidden qty input) ── */
(function(){
  const out=$('#qOut'),minus=$('#qMinus'),plus=$('#qPlus'),input=$('#qtyInput');
  if(!out)return;let q=parseInt(out.textContent,10)||1;
  const set=v=>{q=clamp(v,1,9);out.textContent=q;if(input)input.value=q;};
  if(plus)plus.onclick=()=>set(q+1);if(minus)minus.onclick=()=>set(q-1);
})();

/* ── story: scroll progress ── */
(function(){
  const prog=$('#prog');if(!prog){return;}
  addEventListener('scroll',()=>{const h=document.documentElement.scrollHeight-innerHeight;prog.style.width=(scrollY/(h||1)*100)+'%';},{passive:true});
})();

})();
